import axios from 'axios'
import global from './common'
import JSEncrypt from 'jsencrypt'
const http = {}

// //添加请求拦截器
// http.interceptors.request.use(
//   config => {
//     return config
//   },
//   error => {
//     return Promise.error(error)
//   })

// //响应拦截器
// http.interceptors.response.use(
//   response => {
//     if (response.status == 200) {
//       return Promise.resolve(response);
//     } else {
//       return Promise.reject(response);
//     }
//   }
// )

http.pk = null;
http.pkId = null;
http.token = null;
http.encrypt = null;
let array = window.location.pathname.split("/");
let contextName = null;
for (let i = 0; i < array.length; i++) {
  if (array[i] != null && array[i] != "") {
    contextName = "/" + array[i];
    break;
  }
}
http.hostUrl = window.location.protocol + "//" + window.location.host;
http.contextName = contextName;

if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV == "development") {
  http.hostUrl = "http://127.0.0.1:8082";
  http.contextName = "/CyberUICloud3";
}

http.request = function (url, params, callback) {
  url = http.hostUrl + http.contextName + url;
  this.encrypt = new CyberUIEncrypt();
  let seqno = global.getUUID();
  let request = {
    "header": {
      "x-seq-no": seqno,
      "x-package-type": 1,
      "sourceFlag": "CyberUI_WEB"
    },
    "body": params
  }
  if (http.token != null) {
    request["header"]["x-account-token"] = http.token;
  } else {
    http.token = sessionStorage.getItem("token");
    if (http.token == null) {
      console.log("跳转登录页面");
    } else {
      request["header"]["x-account-token"] = http.token;
    }
  }
  if (this.encrypt) {
    this.encrypt.encryptData(params, seqno, function (result) {
      result["data"] = result["params"];
      result["params"] = undefined;
      request["body"] = result;
      var dataStr = JSON.stringify(request);
      global.str2ab(dataStr, function (ab) {
        var base64data = global.ab2Base64(ab)
        if (base64data != null) {
          callback({
            url: url,
            dataStr: base64data
          });
        }
      })
    });
  }
}
http.other = function (url, method, params, callback) {
  this.request(url, params, (map) => {
    axios({
      method: method,
      url: map.url,
      data: map.dataStr
    }).then((response) => {
      //存储pk
      let body = response.data.body;
      let header = response.data.header;
      if (body && header) {
        let seqno = header["x-seq-no"];
        let sign = body["sign"];
        let data = body["data"];
        var ab = global.base642ab(data);
        ab = this.encrypt.encrypt(this.encrypt.localKey + seqno, ab);
        global.ab2str(ab, (str) => {
          //console.log("recv解密后的内容:" + str);
          var jsonResp = JSON.parse(str);
          callback(jsonResp);
        });
      }
    }).catch((error) => {
      callback(error)
    })
  });
}
http.post = function (url, params, callback) {
  this.request(url, params, (map) => {
    axios({
      method: 'POST',
      url: map.url,
      data: map.dataStr
    }).then((response) => {
      //存储pk
      let body = response.data.body;
      let header = response.data.header;
      if (body && header) {
        let seqno = header["x-seq-no"];
        let sign = body["sign"];
        let data = body["data"];
        var ab = global.base642ab(data);
        ab = this.encrypt.encrypt(this.encrypt.localKey + seqno, ab);
        global.ab2str(ab, (str) => {
          //console.log("recv解密后的内容:" + str);
          var jsonResp = JSON.parse(str);
          callback(jsonResp);
        });
      }
    }).catch((error) => {
      callback(error)
    })
  });
}
http.get = function (url, params, callback) {
  url = http.hostUrl + http.contextName + url;
  let requestNoTokenUrls = ["public/"]
  let needToken = true
  for (let i = 0; i < requestNoTokenUrls.length; i++) {
    let requestNoTokenUrl = requestNoTokenUrls[i]
    if (url.search(requestNoTokenUrl) != '-1') {
      needToken = false
    }
  }
  let request = {
    "header": {
      "x-seq-no": global.getUUID(),
      "x-package-type": 0,
      "sourceFlag": "CyberUI_WEB"
    },
    "body": params
  }
  if (needToken) {
    if (http.token != null) {
      request["header"]["x-account-token"] = http.token;
    } else {
      http.token = sessionStorage.getItem("token");
      if (http.token == null) {
        console.log("跳转登录页面");
      } else {
        request["header"]["x-account-token"] = http.token;
      }
    }
  }
  let dataStr = JSON.stringify(request);
  global.str2ab(dataStr, function (ab) {
    let base64data = global.ab2Base64(ab);
    if (base64data != null) {
      url = url + "?content=" + base64data;
      // console.log(url)
      axios({
        method: 'GET',
        url: url
      }).then((response) => {
        //存储pk
        var body = response.data.body
        if (body.result.pk != undefined) {
          http.pk = body.result.pk
        }
        if (body.result.pkId != undefined) {
          http.pkId = body.result.pkId
        }
        callback(body)
      }).catch((error) => {
        callback(error)
      })
    }
  })
}
http.getCommon = function (url, params, callback) {
  url = http.hostUrl + http.contextName + url;
  axios({
    method: 'GET',
    params: params,
    url: url
  }).then((response) => {
    callback(response);
  }).catch((error) => {
    callback(error)
  })
}

http.login = function (username, password, callback) {
  let et = new JSEncrypt()
  et.setPublicKey('-----BEGIN PUBLIC KEY-----' + this.pk + "-----END PUBLIC KEY-----")
  let rsaPwd = et.encrypt(password)
  let jsonData = {}
  jsonData["pkId"] = this.pkId
  jsonData["username"] = username
  jsonData["pwd_secure"] = rsaPwd
  let url = "/CyberUICloud/public/api/login"
  this.post(url, jsonData, function (response) {
    let state = response.state
    if (state == 0) {
      let token = response.result.token
      if (token != undefined) {
        http.token = token
        sessionStorage.setItem("token", token)
      }
    }
    callback(response)
  })
}

//加载加密模块
http.getJSXModule = function (callback) {
  let url = "/CyberUICloud/public/api/jsxModule/encrypt"
  this.get(url, {}, function (response) {
    let jsx = response["result"];
    let abJsx = global.base642ab(jsx)
    global.str2ab(http.token, function (abToken) {
      console.log(abToken)
      let b64Token = global.ab2Base64(abToken)
      abJsx = global.simpleConfuse(abJsx, b64Token)
      global.ab2str(abJsx, function (str) {
        console.log(str)
        sessionStorage.setItem("encrypt", str)
        eval(str)
        http.encrypt = new CyberUIEncrypt();
        console.log(http.encrypt.localKey)
        callback({ "state": 0, "msg": "ok" })
      })
    })
  })
}

var CyberUIEncrypt = function () {
  this.localKey = window.generateLocalSignFix();
}
CyberUIEncrypt.prototype.encrypt = function (key, data) {
  var ret = null;
  if (typeof key == "string") {
    // 此处key不能有非ascii字符
    var keyBuffer = new Uint8Array(key.length);
    for (var i = 0; i < key.length; i++) {
      keyBuffer[i] = key.charCodeAt(i);
    }
    key = keyBuffer;
  }
  if (data instanceof Uint8Array) {

  } else {
    data = new Uint8Array(data);
  }
  ret = new Uint8Array(data.byteLength);
  var tmpKey = new Uint8Array(key.byteLength);
  for (var i = 0; i < key.byteLength; i++) {
    tmpKey[i] = key[i];
  }
  // 做了一次奇偶位互换
  for (var i = 0; i < tmpKey.byteLength; i += 2) {
    var tmp = tmpKey[i];
    tmpKey[i] = tmpKey[i + 1];
    tmpKey[i + 1] = tmp;
  }
  // 对源数据进行byte级别混淆
  var j = 0;
  for (var i = 0; i < data.byteLength; i++) {
    if (j > tmpKey.byteLength - 1) {
      j = 0;
    }
    if (i > 0 && i % 3 == 0) {
      ret[i] = ~data[i];
    } else {
      ret[i] = data[i] ^ tmpKey[j];
      j++;
    }
  }
  return ret;
}
CyberUIEncrypt.prototype.getSign = function (content, key) {
  var ret = null;
  var temp = content + this.localKey + key;
  temp = global.md5(temp);
  ret = temp.substring(temp.length - 8);
  return ret;
}

CyberUIEncrypt.prototype.encryptData = function (data, varKey, f) {
  var sourceStr = null;
  if (typeof data == "string") {
    sourceStr = data;
  } else if (typeof data == "object") {
    sourceStr = JSON.stringify(data);
  }
  var self = this;
  global.str2ab(sourceStr, function (ab) {
    var bytes = new Uint8Array(ab);
    bytes = self.encrypt(self.localKey + "" + varKey, bytes);
    var base64 = global.ab2Base64(bytes);
    var sign = self.getSign(base64, varKey + "");
    var result = {};
    result["params"] = base64;
    result["sign"] = sign;
    if (f != undefined) {
      f(result);
    }
  });
}

window.generateLocalSignFix = function () {
  var array = [];
  array.push(108);
  array.push(119);
  array.push(72);
  array.push(70);
  array.push(84);
  array.push(81);
  var ret = "";
  for (var i = 0; i < array.length; i++) {
    ret += String.fromCharCode(array[i]);
  }
  return ret;
}
export default http